import { render, staticRenderFns } from "./empty.mpx?vue&type=template&id=ed16b08c&scoped=true&component=true&componentId=empty04f86cf9"
import script from "./empty.mpx?vue&type=script&lang=js&component=true&componentId=empty04f86cf9"
export * from "./empty.mpx?vue&type=script&lang=js&component=true&componentId=empty04f86cf9"
import style0 from "./empty.mpx?vue&type=style&index=0&id=ed16b08c&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m04f86cf9%22%7D&component=true&componentId=empty04f86cf9"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed16b08c",
  null
  
)

export default component.exports